module.exports = __webpack_public_path__ + "static/media/code-memoji.c2454f7f.png";